import { IController } from 'angular';
import * as _ from 'lodash';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { ICurrentState, SchoolToolbarService } from './../../layout/toolbars/school-toolbar/school-toolbar.service';

import { SpinnerModal } from './../../shared/modals/status-spinner/status-spinner.service';
import { ISdcStore } from './../flux/sdc-store.interface';
import { SdcStateService } from './../sdc-state/sdc-state.service';

type TValidStateSuffix = 'wizard' | 'grid' | 'profile';

interface ISdcNavLink {
  humanName: TValidStateSuffix;
  state: string;
  isDisabled: boolean;
}

export class SdcToolbarMenuCtrl implements IController {
  static $inject: string[] = [
    '$state',
    'ObjectCache',
    'SDCStore',
    'SpinnerModal',
    'SdcStateService',
    'SchoolToolbarService',
    'ImUser',
  ];

  public navs: ISdcNavLink[];

  // bindings
  public currentUser;
  public currentState: ICurrentState;

  constructor(
    private $state,
    private ObjectCache,
    private SDCStore: ISdcStore,
    private SpinnerModal: SpinnerModal,
    private SdcStateService: SdcStateService,
    private schoolToolbarService: SchoolToolbarService,
    private imUser: ImUser,
  ) {
    //
  }

  $onInit() {
    const currentState = this.currentState || this.schoolToolbarService.getCurrentState();

    this.navs = this.getNavLinks(currentState);
  }

  $onChanges(changesObj) {
    const { currentState: _currentState } = changesObj;

    if (_currentState && !_currentState.isFirstChange()) {
      const currentState: ICurrentState = _currentState.currentValue;
      this.navs = this.getNavLinks(currentState);
    }
  }

  currentSdcName() {
    return this.$state.current.name;
  }

  currentSuffix() {
    const currName = this.currentSdcName().split('.');
    return currName.pop();
  }

  // Dynamically build navigation links based on current sdc/state
  public getNavLinks(currentState: ICurrentState): ISdcNavLink[] {
    const navs: ISdcNavLink[] = [];
    const uiState = this.SDCStore.getUiState();

    // Not an SDC route
    if (!currentState.name && !currentState.name.includes('single-student')) {
      return [];
    }

    const currentStateString = this.$state.current.name;
    const currentStateArr = currentStateString.split('.');

    // Will be either wizard or grid
    const currentStateSuffix = currentStateArr.pop();
    const availableViews = currentState.availableSdcViews || [];

    // For each SDC view type, if its included in the SDCState constant, include it in the nav.
    // Also disable the currently active view
    if (_.includes(availableViews, 'wizard')) {
      const state = uiState.currentActivity.state + '.wizard';

      if (this.imUser.canAccessState(this.currentUser, state)) {
        navs.push({
          humanName: 'wizard',
          state,
          isDisabled: currentStateSuffix === 'wizard',
        });
      }
    }

    if (_.includes(availableViews, 'grid')) {
      const state = uiState.currentActivity.state + '.grid';

      if (this.imUser.canAccessState(this.currentUser, state)) {
        navs.push({
          humanName: 'grid',
          state,
          isDisabled: currentStateSuffix === 'grid',
        });
      }
    }

    // If currently on grid OR wizard push profile
    if (_.includes(availableViews, 'profile')) {
      const state = uiState.currentActivity.state + '.profile';

      if (this.imUser.canAccessState(this.currentUser, state)) {
        navs.push({
          humanName: 'profile',
          state,
          isDisabled: currentStateSuffix !== 'wizard' && currentStateSuffix !== 'grid',
        });
      }
    }

    return navs;
  }

  goToState(newState) {
    this.SpinnerModal.activateSpinner('Changing view...');
    this.$state.go(newState);
  }

  stateIsActive(state) {
    return this.$state.current.name === state;
  }
}
